

export const getLimitedPhotoDataHandler=(payload)=>{
    return{
        type:"LIMITED_PHOTO_DATA",
        payload
    }
}

